const wowApp = require('angular').module('wowApp.common');
wowApp.service('TestLocalStorage', ['$window', require('./test-local-storage')]);
wowApp.service('InMemoryStorage', ['$window', require('./in-memory-storage')]);
wowApp.factory('LocalStorageService', ['TestLocalStorage', 'InMemoryStorage', '$window', require('./local-storage-factory')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/localStorage/index.js
 **/